import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/aleksundshantu/schahina-gambir-2026-frontend/apps/template-standard/src/app/layout.client.tsx");
;
import(/* webpackMode: "eager" */ "/builds/aleksundshantu/schahina-gambir-2026-frontend/apps/template-standard/src/style.scss");
